import {IText} from "../../interface";

export const ContactText : IText = {
    title : "Начать ",
    title1 : "сотрудничество",
    addressTitle : 'Адрес',
    address : '420111, Республика Татарстан, г. Казань, ул. Кремлевская, д. 21, помещ. 1005',
    contact : 'Контакты',
    phone : '+7 (843) 248-55-54',
    email : 'projects@deck.lc'
}
